var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 107.2992125984252 108.38845144356955",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l107.29921 0l0 108.38845l-107.29921 0l0 -108.38845z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l107.29921 0l0 108.38845l-107.29921 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m5.2349114 54.194347l0 0c0 -26.738726 21.676022 -48.414745 48.414745 -48.414745l0 0c12.840385 0 25.15487 5.100825 34.234398 14.180351c9.079521 9.079527 14.180351 21.394007 14.180351 34.234398l0 0c0 26.738728 -21.676025 48.414745 -48.41475 48.414745l0 0c-26.738726 0 -48.414745 -21.676018 -48.414745 -48.414745z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m5.2349114 54.194347l0 0c0 -26.738726 21.676022 -48.414745 48.414745 -48.414745l0 0c12.840385 0 25.15487 5.100825 34.234398 14.180351c9.079521 9.079527 14.180351 21.394007 14.180351 34.234398l0 0c0 26.738728 -21.676025 48.414745 -48.41475 48.414745l0 0c-26.738726 0 -48.414745 -21.676018 -48.414745 -48.414745z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m53.642033 55.9091l0 -38.07874",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m53.642033 55.9091l0 -38.07874",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m75.35696 66.06562l-22.614174 -12.000004",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m75.35696 66.06562l-22.614174 -12.000004",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.d6a994eda38d0587366cf6e9fe455310.svg";
export { ForwardRef as ReactComponent };